import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../../config";
import classes from "./Chats.module.css";
import Button from "../ui/Button";

function Chats({ user }) {
  const [chats, setChats] = useState([]);

  const [isWorking, setIsWorking] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    setIsWorking(true);
    setError(null);
    fetch(API_URL + "api/messages", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + user.token,
      },
    })
      .then((response) => {
        if (!response.ok)
          setError({
            message: `(${response.status}) ${response.statusText} ${
              response.ok ? "OK" : "NOT OK"
            }`,
          });
        else return response.json();
      })
      .then((data) => {
        setChats(data);
      })
      .catch((err) => {
        setError({ message: "Can't fetch chats. See console" });
        console.log(err);
      })
      .finally(() => setIsWorking(false));
  }, [user.token]);

  return (
    <div className={classes.chats}>
      <div className={classes.title}>
        <span>Recent Messages</span>
        <Button
          style={{ fontSize: "1em" }}
          disabled={isWorking}
          onClick={() => navigate("users")}
        >
          New message
        </Button>
      </div>
      {isWorking || error ? (
        <div className={classes.info}>
          {isWorking && <div>Loading...</div>}
          {error && <div>Errror: {error.message}</div>}
        </div>
      ) : (
        <div className={classes.actions}>
          {/* <Link to={"users"}>Send new message</Link> */}
        </div>
      )}

      {chats && chats.length ? (
        <ul className={classes.list}>
          {chats.map((chat) => (
            <Link key={chat.chatId} to={chat.chatId}>
              {chat.username}
            </Link>
          ))}
        </ul>
      ) : (
        <div className={classes.list}>
          <span>No chats found</span>
        </div>
      )}
    </div>
  );
}

export default Chats;
